<template>
  <div ref="pbrTopicInfographicChart" class="pbr-topic-chart-container" style="height: 190px;">
    信息图谱
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {chartColors} from '../analysis/constant'

export default {
  name: 'pbrTopicInfographicChart',
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    }
  },
  data () {
    return {
      chartData: []
    }
  },
  computed: {
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    }
  },
  methods: {
    drawChart (theme = 'light') {
      let self = this
      if (this.pbrTopicInfographicChart) {
        this.pbrTopicInfographicChart.dispose()
      }
      // {renderer: 'svg',}
      if (this.$refs.pbrTopicInfographicChart) {
        this.pbrTopicInfographicChart = echarts.init(this.$refs.pbrTopicInfographicChart, theme, {devicePixelRatio: 2.5})
        // this.pbrTopicInfographicChart.resize({height: 200})
        this.pbrTopicInfographicChart.resize({width: 200})
        this.pbrTopicInfographicChart.setOption(this.optionPbrTopicInfographicChart)
        this.pbrTopicInfographicChart.on('click', function (param) {

        })
      }
    },
    generateOptions () {
      let categories = []
      for (let i = 0; i < 2; i++) {
        categories[i] = {
          name: '类目' + i
        }
      }

      let self = this
      this.optionPbrTopicInfographicChart = {
        // 提示框的配置
        tooltip: {
          formatter: function (x) {
            return x.data.des
          }
        },
        // 工具箱
        toolbox: {
          // 显示工具箱
          show: true,
          feature: {
            mark: {
              show: true
            },
            // 还原
            restore: {
              show: true
            }
            // // 保存为图片
            // saveAsImage: {
            //   show: true
            // }
          }
        },
        legend: [{
          // selectedMode: 'single',
          orient: 'vertical',
          top: 'center',
          right: 0,
          itemHeight: 7,
          itemWidth: 7,
          data: categories.map(function (a) {
            return a.name
          }),
          textStyle: {
            fontSize: 10,
            lineHeight: 10,
            color: self.isDark ? '#fff' : '#101010'
          }
        }],
        series: [{
          type: 'graph', // 类型:关系图
          layout: 'force', // 图的布局，类型为力导图
          symbolSize: 40, // 调整节点的大小
          roam: true, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移,可以设置成 'scale' 或者 'move'。设置成 true 为都开启
          zoom: 0.5,
          edgeSymbol: ['circle', 'arrow'],
          edgeSymbolSize: [2, 10],
          force: {
            repulsion: 2500,
            edgeLength: [10, 50]
          },
          draggable: true,
          lineStyle: {
            normal: {
              width: 2,
              color: '#4b565b'
            }
          },
          edgeLabel: {
            normal: {
              show: true,
              formatter: function (x) {
                return x.data.name
              },
              textStyle: {
                fontSize: 10,
                color: self.isDark ? '#fff' : 'inherit'
              }
            }
          },
          label: {
            normal: {
              show: true,
              textStyle: {}
            }
          },

          // 数据
          data: [{
            name: 'node01',
            des: 'nodedes01',
            symbolSize: 70,
            category: 0
          }, {
            name: 'node02',
            des: 'nodedes02',
            symbolSize: 50,
            category: 1
          }, {
            name: 'node03',
            des: 'nodedes3',
            symbolSize: 50,
            category: 1
          }, {
            name: 'node04',
            des: 'nodedes04',
            symbolSize: 50,
            category: 1
          }, {
            name: 'node05',
            des: 'nodedes05',
            symbolSize: 50,
            category: 1
          }],
          links: [{
            source: 'node01',
            target: 'node02',
            name: 'link01',
            des: 'link01des'
          }, {
            source: 'node01',
            target: 'node03',
            name: 'link02',
            des: 'link02des'
          }, {
            source: 'node01',
            target: 'node04',
            name: 'link03',
            des: 'link03des'
          }, {
            source: 'node01',
            target: 'node05',
            name: 'link04',
            des: 'link05des'
          }],
          categories: categories
        }]
      }
    }
  },
  mounted () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    data: {
      handler (newValue, oldValue) {
        debugger
        const pbrTopicInfographicChartData = newValue
        if (pbrTopicInfographicChartData && pbrTopicInfographicChartData.length > 0 && pbrTopicInfographicChartData.hasOwnProperty('percentage')) {
          this.chartData = pbrTopicInfographicChartData
        } else {
          this.chartData = [{id: '', name: '', percentage: 0}]
        }
        if (this.pbrTopicInfographicChart) {
          this.pbrTopicInfographicChart.dispose()
        }
        this.generateOptions()
        this.drawChart(this.theme)
      }
      // immediate: true
    },
    isDark (n, o) {
      this.generateOptions()
      this.drawChart(this.theme)
    }
  }
}
</script>

<style scoped>

</style>
